module.exports = __webpack_public_path__ + "assets/img/lg2.28db6e51.png";